<div class="yandex-banner">
  <div class="yandex-banner-left">
    <div class="yandex-banner-left-top">
      <div class="yandex-banner-left-top-first">
        <svg width="141" height="28" viewBox="0 0 141 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="&#208;&#175; &#208;&#145;&#208;&#184;&#208;&#183;&#208;&#189;&#208;&#181;&#209;&#129; &#208;&#155;&#208;&#190;&#208;&#179;&#208;&#190; 224 &#226;&#156;&#149; 48" clip-path="url(#clip0_10537_11820)">
            <g id="Group">
              <path id="&#208;&#145;&#208;&#184;&#208;&#183;&#208;&#189;&#208;&#181;&#209;&#129;" fill-rule="evenodd" clip-rule="evenodd" d="M39.9118 11.4384L46.9996 11.4335C51.4682 11.4335 53.7791 13.4551 53.7808 17.0325C53.7808 19.5217 52.5641 22.6332 47.0078 22.6332H34.6719V5.36694H52.5462V9.25546H39.9102L39.9118 11.4384ZM46.3831 18.743C47.771 18.743 48.5408 18.1207 48.5408 17.0325C48.5408 15.9443 47.7694 15.322 46.3831 15.322H39.9102V18.743H46.3831ZM88.1431 18.7439V18.8987C88.1431 21.3879 85.524 22.9436 80.5939 22.9436H79.9774C74.7374 22.9436 72.4265 20.9203 72.4265 18.3077V18.1233L77.5115 18.1216C77.6648 19.521 78.8978 19.8321 80.4389 19.8321C82.1677 19.8321 83.0581 19.521 83.0581 18.5875C83.0581 17.6393 82.4351 17.3446 81.1207 17.3446L78.4362 17.3429V14.5426H81.0554C82.135 14.5426 82.5966 14.2315 82.5966 13.4544C82.5966 12.6757 81.8268 12.2098 80.2856 12.2098C78.7445 12.2098 77.9763 12.6757 77.8198 13.6092H72.5798V13.4511C72.5798 10.8088 75.6621 9.40949 80.1307 9.40949H80.4389C84.9075 9.40949 87.6816 10.6541 87.6816 12.8321V13.1433C87.6816 15.0101 85.9235 15.7131 84.8455 15.9452C86.1584 16.2004 88.1431 16.7223 88.1431 18.7439ZM118.243 18.5875H123.432C123.432 19.6774 122.489 22.9436 115.579 22.942H114.951C108.513 22.942 106.942 19.442 106.942 16.3387V16.0127C106.942 12.8321 108.328 9.40949 114.955 9.40949H115.418C122.352 9.40949 123.43 12.9869 123.43 16.7124V17.1865L112.016 17.1849C112.174 18.7406 113.262 19.6757 115.516 19.6757C117.733 19.6757 118.051 18.9952 118.211 18.6529C118.222 18.6294 118.233 18.6075 118.243 18.5875ZM118.194 14.6974C118.194 13.6092 117.577 12.521 115.111 12.521C112.954 12.521 112.182 13.4544 112.029 14.699L118.194 14.6974ZM135.895 17.5003H141C141 19.3671 139.767 22.9445 133.14 22.9429H132.832C126.206 22.9429 124.82 18.8996 124.82 16.4104V15.9445C124.82 13.457 126.129 9.41042 132.832 9.41206H133.14C139.687 9.41042 141 12.8347 141 14.7016H135.915C135.782 13.9229 135.143 12.8347 133.14 12.8347H132.832C130.83 12.8347 129.905 14.3904 129.905 16.1009V16.2557C129.905 17.9678 130.983 19.3671 132.832 19.3671H133.14C135.298 19.3671 135.761 18.1226 135.895 17.5003ZM100.471 22.6337H105.403V9.72352H100.471V14.3891H94.6161V9.72352H89.6843V22.6337H94.6161V17.9665H100.471V22.6337ZM66.1069 22.6337H71.0386V9.72352H65.9536L60.252 17.1894V9.72352H55.3203V22.6337H60.4053L66.1069 15.1678V22.6337Z" fill="white"/>
              <g id="&#208;&#175;">
                <path id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M27.7378 14C27.7378 21.732 21.5285 28 13.8689 28C6.20932 28 0 21.732 0 14C0 6.26801 6.20932 0 13.8689 0C21.5285 0 27.7378 6.26801 27.7378 14ZM18.3425 21.9808V6.00195H14.3583C10.5046 6.00195 8.20506 7.93469 8.20506 11.1713C8.20506 13.7164 9.49508 15.1701 11.4326 16.5711L11.4652 16.5941L11.4423 16.6271L7.87236 21.9956H10.7818L14.7726 15.9751L13.4059 15.045C11.6853 13.8663 10.8666 12.9624 10.8666 11.0067C10.8666 9.18257 12.1779 8.09273 14.373 8.09273H15.6108H15.6516V8.13389V21.9808H18.3425Z" fill="white"/>
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_10537_11820">
              <rect width="141" height="28" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="yandex-banner-left-top-second">
        <div class="yandex-banner-left-top-second-corner"></div>
      </div>
    </div>
    <div class="yandex-banner-left-bottom">
      <div class="yandex-banner-left-bottom-title">{{'Яндекс Бизнес настроит и запустит рекламу за вас' | translate}}</div>
      <div class="yandex-banner-left-bottom-desc">{{'Казахтелеком совместно с Яндексом дарит пользователям Ismet Partner 30 000 ₸ на первый запуск рекламы!' | translate}}</div>
      <button (click)="openAuth()">{{'Запустить рекламу' | translate}}</button>
    </div>
  </div>
</div>


<div class="top-block mt-4">
  <div class="top-left-part">
    <div class="main-wrapper">
      <div class="main-header">
        {{ 'Мы помогаем компаниям находить друг друга!' | translate }}
      </div>
      <div class="main-desc">
        {{ 'Присоединяйтесь к готовой базе потенциальных клиентов, совершайте выгодные сделки, находите надёжных партнёров и развивайте свой бизнес' | translate }}
      </div>
    </div>
    <div class="">
      <img src="assets/images/main/top-main-page-image.svg" alt="">
    </div>
  </div>
  <div class="top-right-part">
    <div class="part-header mb-3" [ngClass]="{'text-4xl': translate.currentLang == 'kz'}">
      {{ 'Хочу купить' | translate }}
    </div>
    <div class="part-desc">
      {{ 'Введите название товара или услуги для получения лучших предложений' | translate }}
    </div>
    <div class="mb-3">
      <input class="w-full" [placeholder]="'Что хотите купить?' | translate" [(ngModel)]="searchService._name">
    </div>
    <div class="search-partners" (click)="findPartner()" [routerLink]="'/search'">
      {{ 'Найти партнёров' | translate }}
    </div>
  </div>
</div>
<!-- id категорий сделаны хард кодом, если бэк поменяет то надо менять тут-->
<div class="category-types">
    <div class="category-type-item" (click)="type = 1" [ngClass]="{'active': type == 1}">
        {{ 'Товары' | translate }}
    </div>
    <div class="category-type-item" (click)="type = 2" [ngClass]="{'active': type == 2}">
        {{ 'Услуги' | translate }}
    </div>
</div>
<div class="" *ngIf="type == 1">
    <div class="category-block">
        <div (click)="goToCategory(headerService._catalog[0].parentlist[5], 2, 5,2, headerService._catalog[0].parentlist, 1)"  class="category-item">
            <div class="category-name">
                {{ 'Авто и транспорт' | translate }}
            </div>
            <img src="assets/images/categories-block/1.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[0].parentlist[3], 2, 3,2,headerService._catalog[0].parentlist, 1)" class="category-item">
            <div class="category-name">
                {{ 'Красота и здоровье' | translate }}
            </div>
            <img src="assets/images/categories-block/2.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[0].parentlist[0], 2, 0,2,headerService._catalog[0].parentlist, 1)" class="category-item">
            <div class="category-name">
                {{ 'Техника и электроника' | translate }}
            </div>
            <img src="assets/images/categories-block/3.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[0].parentlist[1].child_categories[3],3,3,3,headerService._catalog[0].parentlist[1].child_categories, 1, true)" class="category-item">
            <div class="category-name">
                {{ 'Системы безопасности' | translate }}
            </div>
            <img src="assets/images/categories-block/4.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[0].parentlist[2], 2, 2,2,headerService._catalog[0].parentlist, 1)" class="category-item">
            <div class="category-name">
                {{ 'Сеть и телекоммуникации' | translate }}
            </div>
            <img src="assets/images/categories-block/5.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[0].parentlist[4], 2, 4,2,headerService._catalog[0].parentlist, 1)" class="category-item">
            <div class="category-name">
                {{ 'Офис и строительство' | translate }}
            </div>
            <img src="assets/images/categories-block/6.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[0].parentlist[8], 2, 8,2,headerService._catalog[0].parentlist, 1)" class="category-item">
            <div class="category-name">
                {{ 'Сельское хозяйство и продукты питания' | translate }}
            </div>
            <img src="assets/images/categories-block/7.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[0].parentlist[6], 2, 6,2,headerService._catalog[0].parentlist, 1)" class="category-item">
            <div class="category-name">
                {{ 'Оборудование и инструменты' | translate }}
            </div>
            <img src="assets/images/categories-block/8.png" alt="">
        </div>
    </div>
</div>

<div class="" *ngIf="type == 2">
    <div class="category-block">
        <div (click)="goToCategory(headerService._catalog[1].parentlist[3],2,3,2,headerService._catalog[1].parentlist, 2)"  class="category-item">
            <div class="category-name">
                {{ 'Бытовые услуги' | translate }}
            </div>
            <img src="assets/images/categories-block/10.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[1].parentlist[8],2,8,2,headerService._catalog[1].parentlist, 2)" class="category-item">
            <div class="category-name">
                {{ 'Реклама и дизайн' | translate }}
            </div>
            <img src="assets/images/categories-block/11.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[1].parentlist[9],2,9,2,headerService._catalog[1].parentlist, 2)" class="category-item">
            <div class="category-name">
                {{ 'Медицина и страхование' | translate }}
            </div>
            <img src="assets/images/categories-block/12.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[1].parentlist[5],2,5,2,headerService._catalog[1].parentlist, 2)" class="category-item">
            <div class="category-name">
                {{ 'Охранные и аварийные службы' | translate }}
            </div>
            <img src="assets/images/categories-block/13.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[1].parentlist[6],2,6,2,headerService._catalog[1].parentlist, 2)" class="category-item">
            <div class="category-name">
                {{ 'Аутсорсинг' | translate }}
            </div>
            <img src="assets/images/categories-block/14.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[1].parentlist[7],2,7,2,headerService._catalog[1].parentlist, 2)" class="category-item">
            <div class="category-name">
                {{ 'IT-Услуги' | translate }}
            </div>
            <img src="assets/images/categories-block/15.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[1].parentlist[1],2,1,2,headerService._catalog[1].parentlist, 2)" class="category-item">
            <div class="category-name">
                {{ 'Обучение и тренинги' | translate }}
            </div>
            <img src="assets/images/categories-block/16.png" alt="">
        </div>
        <div (click)="goToCategory(headerService._catalog[1].parentlist[0],2,0,2,headerService._catalog[1].parentlist, 2)" class="category-item">
            <div class="category-name">
                {{ 'Строительство сетей' | translate }}
            </div>
            <img src="assets/images/categories-block/17.png" alt="">
        </div>
    </div>
</div>
